"use client"

import { usePathname, useRouter, useSearchParams } from "next/navigation"
import React, { useCallback, useState, useEffect } from "react"
import { MagnifyingGlass } from "@medusajs/icons"

const CategorySearch = ({ q }: { q?: string }) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const [searchValue, setSearchValue] = useState(q || "")

  // Update local state when q prop changes (e.g. on navigation)
  useEffect(() => {
    setSearchValue(q || "")
  }, [q])

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams)
      if (value) {
        params.set(name, value)
      } else {
        params.delete(name)
      }
      // Reset page when searching
      params.delete("page")
      return params.toString()
    },
    [searchParams]
  )

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    const query = createQueryString("q", searchValue)
    router.push(`${pathname}?${query}`)
  }

  return (
    <div className="mb-6 w-full max-w-md">
      <form onSubmit={handleSearch} className="relative">
        <input
          type="text"
          placeholder="Buscar en esta categoría..."
          className="w-full h-10 pl-10 pr-4 py-2 bg-ui-bg-field border border-ui-border-base rounded-full txt-compact-medium focus:outline-none focus:ring-2 focus:ring-ui-bg-interactive transition-all"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-ui-fg-subtle">
          <MagnifyingGlass />
        </div>
        {searchValue && (
            <button 
                type="button"
                onClick={() => {
                    setSearchValue("")
                    router.push(`${pathname}?${createQueryString("q", "")}`)
                }}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-ui-fg-muted hover:text-ui-fg-base"
            >
                ×
            </button>
        )}
      </form>
    </div>
  )
}

export default CategorySearch
